import React, { Component } from 'react';
import '../styles/Button.css';

class Button extends Component {
  render() {
    return (
      <button className="Button w-100 mw5-ns center b" {...this.props} />
    );
  }
}

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js